import ShareButton from './ShareButton.js'

ShareButton.register()
